// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/video-js"], () => (__webpack_require__("./blocks/video-popup/view.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/video-js"], () => (__webpack_require__("./assets/scss/video-js.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
